module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/reply-97ccfdb1136e9df9604810e1c03cc022.svg";